module.exports = __webpack_public_path__ + "static/img/case-glj-page-bg-03.5d01562.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/glj/case-glj-page-bg-03.jpg
// module id = dV80
// module chunks = 1